export default __webpack_public_path__ + "static/semibold-9091346bf73a18dcc65f1822f86876ef.woff2";